import React from "react";
import styled from "styled-components";
import { Card, Typography, Box } from "@bca/ui-library";
import { layout, LayoutProps } from "styled-system";

import ClockSVG from "./Icons/ClockSVG";

interface NoOptionAvailableProps {
  saleStartDate: string;
}

const CardWithLayout = styled(Card)<LayoutProps>`
  ${layout}
`;

const NoOptionAvailable: React.FunctionComponent<NoOptionAvailableProps> = ({
  saleStartDate,
}) => {
  return (
    <CardWithLayout
      width="100%"
      height="130px"
      marginX={0}
      marginY={0}
      maxWidth={["100%", "60%", "622px"]}
    >
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <ClockSVG width={18} height={18} />
        <Typography
          variant="body"
          color="grey-blue"
          mt={1}
          mb={0}
          textAlign="center"
          css={`
            max-width: 285px;
          `}
        >
          Buying Options will be available
        </Typography>
        <Typography
          variant="body"
          color="grey-blue"
          mt={1}
          mb={0}
          textAlign="center"
          css={`
            max-width: 285px;
          `}
        >
          {saleStartDate}
        </Typography>
      </Box>
    </CardWithLayout>
  );
};

export default NoOptionAvailable;
